import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconAccountParent = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7692 4.92308H12.3077V7.38462H14.7692V4.92308Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7692 9.84615H12.3077V12.3077H14.7692V9.84615Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7692 14.7692H12.3077V17.2308H14.7692V14.7692Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7692 19.6923H12.3077V22.1538H14.7692V19.6923Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.6923 4.92308H17.2308V7.38462H19.6923V4.92308Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.6923 9.84615H17.2308V12.3077H19.6923V9.84615Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.6923 14.7692H17.2308V17.2308H19.6923V14.7692Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.6923 19.6923H17.2308V22.1538H19.6923V19.6923Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.7692 29.5385H24.6154V7.38462H27.0769V25.8462C27.0769 26.1726 27.2066 26.4856 27.4374 26.7164C27.6682 26.9473 27.9813 27.0769 28.3077 27.0769C28.6341 27.0769 28.9472 26.9473 29.178 26.7164C29.4088 26.4856 29.5385 26.1726 29.5385 25.8462V6.15385C29.5385 5.82743 29.4088 5.51438 29.178 5.28356C28.9472 5.05275 28.6341 4.92308 28.3077 4.92308H24.6154V1.23077C24.6154 0.904349 24.4857 0.591298 24.2549 0.360484C24.0241 0.12967 23.711 0 23.3846 0H8.61539C8.28896 0 7.97591 0.12967 7.7451 0.360484C7.51429 0.591298 7.38462 0.904349 7.38462 1.23077V4.92308H3.69231C3.36589 4.92308 3.05284 5.05275 2.82202 5.28356C2.59121 5.51438 2.46154 5.82743 2.46154 6.15385V29.5385H1.23077C0.904349 29.5385 0.591298 29.6681 0.360484 29.8989C0.12967 30.1298 0 30.4428 0 30.7692C0 31.0957 0.12967 31.4087 0.360484 31.6395C0.591298 31.8703 0.904349 32 1.23077 32H30.7692C31.0957 32 31.4087 31.8703 31.6395 31.6395C31.8703 31.4087 32 31.0957 32 30.7692C32 30.4428 31.8703 30.1298 31.6395 29.8989C31.4087 29.6681 31.0957 29.5385 30.7692 29.5385ZM4.92308 7.38462H7.38462V25.8462C7.38462 26.1726 7.51429 26.4856 7.7451 26.7164C7.97591 26.9473 8.28896 27.0769 8.61539 27.0769C8.9418 27.0769 9.25486 26.9473 9.48567 26.7164C9.71648 26.4856 9.84615 26.1726 9.84615 25.8462V2.46154H22.1538V29.5385H19.6923V25.8462C19.6923 25.5197 19.5626 25.2067 19.3318 24.9759C19.101 24.7451 18.788 24.6154 18.4615 24.6154H13.5385C13.212 24.6154 12.899 24.7451 12.6682 24.9759C12.4374 25.2067 12.3077 25.5197 12.3077 25.8462V29.5385H4.92308V7.38462ZM17.2308 29.5385H14.7692V27.0769H17.2308V29.5385Z",
			fill: "currentColor"
		})
	]
});
export default SvgIconAccountParent;
